// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changePasswordContainer {
    width: 100%;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: column;
    gap: 30px;
    height: 80vh;
    margin-top: 5vh;
    position: relative;
}

.changePasswordForm {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: start;
    width: 88%;
    position: relative;
}

.changePasswordLabel {
    color: #FFF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.changePasswordInput {
    all: unset;
    border-radius: 12px;
    border: 1px solid #2D2E33;
    background: #070F0F;
    width: 100%;
    padding: 10px;
    height: 8.5vh;
    box-sizing: border-box;
    color: #858585;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.tooltip{
    position: absolute;
    top: 55%;
    left: 6%;
    color: #C15F5F;
    font-size: 12px;
    margin-top: 4px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
}

@media (max-width: 1640px) {
    .changePasswordInput {
        border-radius: 12px;
        padding: 10px;
        font-size: 18px;
    }
    .changePasswordLabel {
        font-size: 18px;
    }
}
@media (max-width: 1440px) {
    .changePasswordInput {
        border-radius: 12px;
        padding: 8px;
        font-size: 16px;
    }
    .changePasswordLabel {
        font-size: 16px;
    }
}
@media (max-width: 1280px) {
    .changePasswordInput {
        border-radius: 10px;
        padding: 6px;
        font-size: 14px;
    }
    .changePasswordLabel {
        font-size: 14px;
    }
}
@media (max-width: 1024px) {
    .changePasswordInput {
        border-radius: 8px;
        padding: 4px;
        font-size: 12px;
    }
    .changePasswordLabel {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChangePassword/ChangePassword.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;QACb,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".changePasswordContainer {\n    width: 100%;\n    display: flex;\n    /* justify-content: center; */\n    align-items: center;\n    flex-direction: column;\n    gap: 30px;\n    height: 80vh;\n    margin-top: 5vh;\n    position: relative;\n}\n\n.changePasswordForm {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: start;\n    width: 88%;\n    position: relative;\n}\n\n.changePasswordLabel {\n    color: #FFF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.changePasswordInput {\n    all: unset;\n    border-radius: 12px;\n    border: 1px solid #2D2E33;\n    background: #070F0F;\n    width: 100%;\n    padding: 10px;\n    height: 8.5vh;\n    box-sizing: border-box;\n    color: #858585;\n    font-family: Inter;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n.tooltip{\n    position: absolute;\n    top: 55%;\n    left: 6%;\n    color: #C15F5F;\n    font-size: 12px;\n    margin-top: 4px;\n    white-space: nowrap;\n    z-index: 10;\n    pointer-events: none;\n}\n\n@media (max-width: 1640px) {\n    .changePasswordInput {\n        border-radius: 12px;\n        padding: 10px;\n        font-size: 18px;\n    }\n    .changePasswordLabel {\n        font-size: 18px;\n    }\n}\n@media (max-width: 1440px) {\n    .changePasswordInput {\n        border-radius: 12px;\n        padding: 8px;\n        font-size: 16px;\n    }\n    .changePasswordLabel {\n        font-size: 16px;\n    }\n}\n@media (max-width: 1280px) {\n    .changePasswordInput {\n        border-radius: 10px;\n        padding: 6px;\n        font-size: 14px;\n    }\n    .changePasswordLabel {\n        font-size: 14px;\n    }\n}\n@media (max-width: 1024px) {\n    .changePasswordInput {\n        border-radius: 8px;\n        padding: 4px;\n        font-size: 12px;\n    }\n    .changePasswordLabel {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
